import { Link } from 'react-router-dom';
import { useTourData } from '../data/tour-data';
import { recordProductTourEventBestEffort } from '../analytics/product-tour-analytics';
import { clearProductTourReturnPath, getProductTourReturnPath, isFirstMachineOnboardingReturnPath } from '../navigation/product-tour-return';

export function TourSummaryPage() {
  const fixture = useTourData();
  const returnPath = getProductTourReturnPath();
  const returningToFirstMachineSetup = isFirstMachineOnboardingReturnPath(returnPath);
  return (
    <section className="r42-page r42-page--wide r42-tour-summary-page" data-tour-target="tour-summary">
      <span className="r42-eyebrow">Route42 Product Tour</span>
      <h1>You're ready to use Route42.</h1>
      <p className="r42-tour-summary-page__lede">The example is deliberately simple: machine evidence becomes grounded understanding that your team can keep developing over time.</p>

      <div className="r42-tour-value-loop" aria-label="Route42 value loop">
        <div><i className="bi bi-file-earmark-text" aria-hidden="true" /><strong>Add evidence</strong><span>Start with useful information you already have.</span></div>
        <i className="bi bi-arrow-right" aria-hidden="true" />
        <div><i className="bi bi-chat-left-text" aria-hidden="true" /><strong>Ask questions</strong><span>Use connected evidence to answer practical machine questions.</span></div>
        <i className="bi bi-arrow-right" aria-hidden="true" />
        <div><i className="bi bi-search" aria-hidden="true" /><strong>Investigate</strong><span>Keep persistent problems, evidence, hypotheses, and unknowns together.</span></div>
        <i className="bi bi-arrow-right" aria-hidden="true" />
        <div><i className="bi bi-cpu" aria-hidden="true" /><strong>Keep learning</strong><span>Machine Memory preserves supported understanding for what comes next.</span></div>
      </div>

      <section className="r42-tour-summary-ace">
        <i className="bi bi-stars" aria-hidden="true" />
        <div><span className="r42-eyebrow">Need help using Route42?</span><h2>Ask Ace.</h2><p>Ace is the product guide for questions about what Route42 means, what you can do on a page, or what to do next. Machine-specific analysis stays in Conversations and Investigations.</p><blockquote>“{fixture.ace_example.prompt}”</blockquote></div>
      </section>

      <div className="r42-tour-summary-actions">
        <Link className="btn r42-btn-primary" to={returnPath} onClick={clearProductTourReturnPath}>{returningToFirstMachineSetup ? 'Continue machine setup' : 'Return to my workspace'}</Link>
        <Link className="btn btn-outline-secondary" to="/tour/machine" onClick={() => recordProductTourEventBestEffort({ event_type: 'TOUR_EXAMPLE_EXPLORED', entry_point: 'TOUR_HOME' })}>Keep exploring the example</Link>
      </div>
    </section>
  );
}
